import { getSiteIconName } from "../../../../utils/CommonUtils";
import CustomIcon from "../../CustomIcons/CustomIcon";
import classes from "./FacilityUserTypesCard.module.css";

const FacilityUserTypesCard = (props) => {
  return (
    <>
      <div className={classes.facilityUserTypes}>
        <div className={classes.facilityContainer}>
          <div className={classes.cardContent}>
            <CustomIcon
              className={classes.siteIcon}
              iconName={getSiteIconName(props.clientId)}
            />
            <div className={classes.cardInfo}>
              <span className={classes.siteName}>{props.displayName}</span>
              <span className={classes.siteAddress}>{props.address}</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FacilityUserTypesCard;
